// extracted by mini-css-extract-plugin
export default {"main":"StatusMessage_main__RWtWh"};